<template>
    <starter-registration v-if="id" :id="id"></starter-registration>
</template>

<script>
    import StarterRegistration from '../../components/admin/StarterRegistration';

    export default {
        components: {
            'starter-registration': StarterRegistration
        },
        data: () => ({
            id: null
        }),
        mounted() {
            if (this.$route.params.id !== undefined) {
                this.id = parseInt(this.$route.params.id);
            }
        }
    }
</script>
